// LabelControl.tsx
import { Control } from '../ControlRenderer';
import { Typography } from '@mui/material';
import { FormModeType } from '@/components/FormDataProvider';
import { evaluateTemplate } from '../utils/Utils';
import React from 'react';
import ControlIcons from '../ControlIcons';

interface LabelControl extends Control {
  fontSize: number;
  labelTemplate?: string;
}

interface LabelControlProps {
  control: Control;
  data: any;
  mode: FormModeType;
}

const LabelControl: React.FC<LabelControlProps> = ({ control, data, mode }) => {

  const labelControl = control as LabelControl;
  const labelStyle: React.CSSProperties = {
    fontSize: `${labelControl.fontSize}px`
  };
  const hasHelp = !!control.helpText || !!control.helpLink;

  switch (control.horizontalAlignment) {
    case 'left':
      labelStyle.textAlign = 'left';
      break;
    case 'center':
      labelStyle.textAlign = 'center';
      break;
    case 'right':
      labelStyle.textAlign = 'right';
      break;
    case 'stretch':
      labelStyle.width = '100%';
      break;
  }

  switch (control.verticalAlignment) {
    case 'top':
      labelStyle.verticalAlign = 'top';
      break;
    case 'middle':
      labelStyle.verticalAlign = 'middle';
      break;
    case 'bottom':
      labelStyle.verticalAlign = 'bottom';
      break;
    case 'stretch':
      labelStyle.height = '100%';
      break;
  }

  const actualLabel = labelControl.labelTemplate ? evaluateTemplate(labelControl.labelTemplate, data, data) : control.label;

  return (
    <div style={{ position: 'relative', width: '100%', display: 'block' }}>
      <Typography
        className='eform-label'
        style={labelStyle}
        sx={{
          pr: hasHelp ? '16px' : 0
        }}
      >
        {actualLabel}
      </Typography>
      {hasHelp && <ControlIcons control={control} />}
    </div>
  );
};

export default LabelControl;
